import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/Pageheader";
import Footer from "../Components/Footer";

function Deliverypage() {
  return (
    <>
      <Header />
      <PageHeader pagename="Delivery Page" />

      {/* Delivery Page Section  */}
      <section className="Delivery-Page-Sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="delivery-page-all">
                <p>
                  This is an informative page that displays all the delivery
                  information and delivery methods supported by ‘Powerful Hand’.
                  Following will be the Delivery Methods: • United Kingdom -
                  £4.99 (2-3 Day Delivery) - Free Delivery on orders over £100!.
                  • Republic of Ireland - £19.99 (Two Day Delivery) • Europe -
                  £29.99 (5 Day Delivery) The following be the Delivery
                  Partners: • Royal Mail • Parcelforce • DPD
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Deliverypage;
